import { Injectable } from '@angular/core';
import { HelperUtilityService } from '@shared/services/helper-utility.service';

import { RunTimeConfigService } from '@shared/services/run-time-config.service';

@Injectable({
  providedIn: 'root'
})
export class FeatureService {
  private readonly globalFeatures: any;
  private readonly appConfig: any;

  constructor(private helperUtilityService: HelperUtilityService, private runTimeConfigService: RunTimeConfigService) {
    this.globalFeatures = this.runTimeConfigService.getConfig('featuresConfig').globalFeatures;
    this.appConfig = this.runTimeConfigService.getConfig('appConfig');
  }

  isFeatureEnabled(featureOrApp: any) {
    let isApp; // global
    let isFeature; // global
    let isListOfApps; // global
    let isFeatureWithinApp; // module specific features

    if (Object.keys(featureOrApp).indexOf('app') > -1) {
      isApp = true;
    }
    if (Object.keys(featureOrApp).indexOf('apps') > -1) {
      isListOfApps = true;
    }
    if (Object.keys(featureOrApp).indexOf('feature') > -1) {
      isFeature = true;
    }
    if (Object.keys(featureOrApp).indexOf('featureWithinApp') > -1) {
      isFeatureWithinApp = true;
    }

    if (isApp) {
      const appDetails = this.getAppDetail(featureOrApp.app);
      if (appDetails && !appDetails.visible) {
        return false;
      } else {
        return true;
      }
    } else if (isListOfApps) {
      let isAnyAppEnabled = false;
      featureOrApp.apps.forEach((app: string) => {
        const appDetails = this.getAppDetail(app);
        if (appDetails.visible) {
          isAnyAppEnabled = true;
        }
      });
      return isAnyAppEnabled;
    } else if (isFeature) {
      const featureDetails = this.getFeatureDetail(featureOrApp.feature);
      if (featureOrApp.hiddenIf) {
        if (
          this.getFeatureDetail(featureOrApp.hiddenIf) &&
          this.getFeatureDetail(featureOrApp.hiddenIf).visible &&
          featureDetails
        ) {
          featureDetails.visible = false;
        }
      }
      if (featureDetails) {
        if (!featureDetails.visible) {
          return false;
        } else {
          return true;
        }
      } else {
        if (featureOrApp.hideIfMissing) {
          return false;
        } else {
          return true;
        }
      }
    } else if (isFeatureWithinApp) {
      if (featureOrApp.features && Object.keys(featureOrApp.features).length > 0) {
        const featureDetails = this.getFeatureDetailWithinApp(featureOrApp);
        if (featureDetails) {
          if (!featureDetails.visible) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      } else {
        console.warn(
          'Warning: Feature within an app was checked against empty feature data! Feature check ignored..' +
            JSON.stringify(featureOrApp)
        );
        return true;
      }
    } else {
      // anything that dont match, show by default
      return true;
    }
  }

  getAppDetail(appName: string) {
    return this.globalFeatures.apps.find(o => o.app.toLowerCase() === appName.toLowerCase());
  }

  getFeatureDetail(featurePath: string) {
    return this.helperUtilityService.stringToObj(featurePath, this.globalFeatures.globalComponents);
  }

  getFeatureDetailWithinApp(featureOrApp: any) {
    return this.helperUtilityService.stringToObj(featureOrApp.featureWithinApp, featureOrApp.features);
  }

  // get first APP Route URL allowed in global features
  getFirstProvisionedRouteURL() {
    const appsList = this.getParsedAppList();

    for (const appCategoryData of appsList) {
      const foundApp = appCategoryData.appList.find(i => i.visible && i.routes);
      if (foundApp) {
        return foundApp.routes[0];
      }
    }
    return '/dashboard/home';
  }

  // get plain list of apps allowed in global features
  getProvisionedAppList() {
    const appsList = this.getParsedAppList();
    const provisionedApps = [];

    Object.keys(appsList).forEach((key, index) => {
      const appCategoryData = appsList[key];
      appCategoryData.appList.map(i => {
        // appList.find(a => a.investor === investor);
        // console.log(i);
        if (i.visible) {
          provisionedApps.push(i.feature.app);
        }
      });
    });
    return provisionedApps;
  }

  getParsedAppList(dontShowInPref?: boolean) {
    // const appsList = JSON.parse(JSON.stringify(this.appConfig.appsList));
    const appsList = this.appConfig.appsList;
    Object.keys(appsList).forEach((key, index) => {
      const appCategoryData = appsList[key];
      let cnt = 0;
      appCategoryData.appList.map(i => {
        if (i.feature) {
          i.visible = this.isFeatureEnabled(i.feature);

          if (i.feature.app) {
            const appDetail = this.getAppDetail(i.feature.app);
            if (appDetail && appDetail.routes) {
              i.routes = appDetail.routes;
            }

            if (appDetail && appDetail.translationsPath) {
              i.translationsPath = appDetail.translationsPath;
            }
          }

          // i.routes = appCategoryData[i].routes;
          if (i.visible) {
            cnt++;
          }
        } else {
          i.visible = true;
        }
        if (dontShowInPref && i.dontShowInPref) {
          i.visible = false;
        }
        return i;
      });

      if (cnt === 0) {
        appCategoryData.visible = false;
      } else {
        appCategoryData.visible = true;
      }
    });

    return appsList;
  }
}
